
import { useMutation } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { Checklist } from 'types'
import { useSnackbarContext } from '../../../context/SnackbarProvider/SnackbarProvider'

interface ChkListData extends Omit<Checklist, 'PK' | 'SK' | 'title' | 'description' | 'status' | 'createdTime' | 'dueDate' | 'assignee' | 'priority'> {
  PK?: string
  SK?: string
  dealId?: string
  title?: string
  description?: string
  status?: string
  createdTime?: string
  dueDate?: string
  assignee?: string
  priority?: string
  [key: string]: any // Allow additional properties
}

const batchPostChecklists = async (checklists: ChkListData[]): Promise<ChkListData[]> => {
  if (!checklists.length) return []

  const createUrl = `${baseUrl}/aws/checklists/batch`
  const response = await axios.post(createUrl, checklists)
  return response.data
}

export const useBatchPostChecklists = () => {
  const { showSnackbar } = useSnackbarContext()

  return useMutation({
    mutationFn: batchPostChecklists,

    onSuccess: data => {
      console.log('✅ Checklists Created Successfully:', data)
      showSnackbar(`Created ${(data as any).count} checklists successfully`, 'success')
      // queryClient.invalidateQueries({ queryKey: ['checklists'] }) // Refresh cache
    },

    onError: error => {
      console.error('[usePostChecklistsBatch] Mutation Error:', error)
      showSnackbar('Error creating checklists', 'error')
    },
  })
}
